module.exports = __webpack_public_path__ + "img/master-card.2d3d6c0b.svg";